import { useAuth } from '@/features/auth/useAuth';
import { useUserVehicles } from './useUserVehicles';

/**
 * Returns true when the authenticated user has zero vehicles.
 *
 * "First run" = signed in + vehicles list loaded (not loading) + empty.
 * Returns false while loading or when unauthenticated.
 */
export function useIsFirstRun(): boolean {
  const { user } = useAuth();
  const { data: vehicles, loading } = useUserVehicles(user?.uid);

  if (!user || loading) return false;
  return vehicles.length === 0;
}
